import { render, staticRenderFns } from "./SubscriptionComponent.vue?vue&type=template&id=b1fa7972&scoped=true&"
import script from "./SubscriptionComponent.vue?vue&type=script&lang=js&"
export * from "./SubscriptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionComponent.vue?vue&type=style&index=0&id=b1fa7972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fa7972",
  null
  
)

export default component.exports